let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8UTG0")).then(() => parcelRequire('as8UH'));